<div class="ca-info-box py-2 px-4 flex flex-col justify-center gap-2 text-center">
    <div class="ca-info-box__value flex justify-center items-center gap-2 ca-headline-3">
        <span [ngClass]="'ca-info-box__value--' + colorVariant()">{{ value() }}</span>
        @if(icon()) {
        <ca-icon class="ca-icon-s-24-p-0-f-24" icon="info-outline">{{ icon() }}</ca-icon>
        }
    </div>
    <div class="ca-info-box__label ca-text-sm">
        <ng-content></ng-content>
    </div>
</div>
